import { store } from "../store";
import { actions } from "@app/utils";
import { getAuthHeaders } from "@app/utils/apiClient";

// import KnowledgeGraph from "@app/assets/urn_aaid_sc_VA6C2_ed993611-2f85-5e1a-b9b0-2badf1cba1b0.json";
import KnowledgeGraph from "@app/assets/urn_aaid_sc_VA6C2_fc6a2c6b-c9cc-539c-a8ad-baa084dfa685.json";

/**
 * Generates the payload for the Adobe Express API request.
 *
 * @param {Object} options - Options for generating the payload.
 * @param {string} options.templateId - The template ID to use.
 * @param {string|null} options.themeId - The theme ID to use, or null for default.
 * @param {string} options.author - The author of the story.
 * @param {string} options.docName - The name of the document.
 * @param {string} options.locale - The locale for the document.
 * @param {Object} options.data - The data to include in the payload.
 *
 * @returns {Object} - The generated payload object.
 */
const generatePayload = ({
  // templateId = "urn:aaid:sc:VA6C2:05792d99-6795-5188-95e1-d38442e124dc",
  // templateId = "urn:aaid:sc:VA6C2:ed993611-2f85-5e1a-b9b0-2badf1cba1b0",
  templateId = "urn:aaid:sc:VA6C2:fc6a2c6b-c9cc-539c-a8ad-baa084dfa685",
  isUserTemplate = true,
  themeId = null, //"urn:aaid:sc:EU:eae97376-ef85-4df1-ae04-d819b50a6664/d9648986-6178-4abf-8476-8d0a74f4f3cf",
  author = "Be Story",
  docName = null,
  locale = "en-US",
  data = {},
} = options) => ({
  "sensei:invocation_mode": "asynchronous",
  "sensei:invocation_batch": false,
  "sensei:in_response": false,
  "sensei:control": true,
  "sensei:engines": [
    {
      "sensei:execution_info": {
        "sensei:engine":
          "Classification:face-crop:Service-6c25a17a1c2f488485aeb09d0229fec4",
      },
      "sensei:inputs": {
        content_fitting_in: {
          requestType: "directContentInput",
          outputType: "docUrl",
          payload: {
            templateId,
            isUserTemplate,
            themeId,
            author,
            docName:
              docName ??
              `[Be Story] ${data.slides?.[0]?.title || "Presentation"}`,
            mimetype: "application/vnd.adobe.hz.express+dcx",
            locale,
            content: data,
            knowledgeGraph: {
              semantic_metadata: KnowledgeGraph,
            },
            authoringExperience: 2, // presentation
            // settings: {
            //   prompt: "",
            //   originApp: "bestory",
            // },
          },
        },
      },
      "sensei:params": {
        content_fitting_config: {},
      },
      "sensei:outputs": {
        content_fitting_out: {
          "dc:format": "application/json",
          "sensei:multipart_field_name": "outfile",
        },
      },
    },
  ],
});

export const generatePresentation = async (data, docName = null) => {
  const formData = new FormData();
  formData.append(
    "contentAnalyzerRequests",
    JSON.stringify(
      generatePayload({
        data,
        docName: docName ? `[Be Story] ${docName}` : null,
        author: store.getState().ims.profile.name,
      }),
    ),
  );

  const authHeaders = await getAuthHeaders(store.getState().ims);

  // IMPORTANT: Remove Content-Type if present - FormData sets it automatically with correct boundary
  const { "Content-Type": _, ...headersWithoutContentType } = authHeaders;

  const response = await fetch(
    actions["exd-storyteller-ai/generatePresentation"],
    {
      method: "POST",
      body: formData,
      headers: headersWithoutContentType, // Let browser set Content-Type with correct boundary
    },
  );

  console.log("Form Data:", { formData });
  console.log("Response from Adobe Express:", { response });

  if (!response.ok) {
    throw new Error("Failed to execute Adobe Express job", response);
  }

  return response.json();
};
